import {
  Component,
  Input,
  OnInit,
  ComponentFactoryResolver,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import * as _ from 'lodash';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'history-pop-up',
  templateUrl: './history-pop-up.component.html',
  styleUrls: ['./history-pop-up.component.scss']
})
export class HistoryPopUpComponent implements OnInit, OnChanges {

  @Input() histories;
  @Input() type;

  public opened = false;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges): void {}
}
